//export const API_REPORTER_BASE_URL = "https://gm2rx81j-8004.inc1.devtunnels.ms/api/v1/reporter"; 


// export const API_REPORTER_BASE_URL = "https://newsapp.aasmo.in/api/v1/reporter"; 
export const API_REPORTER_BASE_URL = " https://backend.xpressnews.in/api/v1/reporter";

export const API_REPORTER_ENDPOINT = {
  // News Creation
  
  GET_DASHBOARD_STATS: `${API_REPORTER_BASE_URL}/dashboard-stats`,
  CREATE_NEWS: `${API_REPORTER_BASE_URL}/news`,
   UPLOAD_MEDIA:`${API_REPORTER_BASE_URL}/upload-media`,
  // Public Lookups (Categories, Subcategories, etc. - can be accessed by reporter)
  GET_ALL_CATEGORIES: `${API_REPORTER_BASE_URL}/categories`,
  GET_ALL_SUBCATEGORIES: `${API_REPORTER_BASE_URL}/subcategories`,

  // For Reporter's "My News" list (if implemented later)
  GET_MY_NEWS: `${API_REPORTER_BASE_URL}/getNewsByReporter`,
    // UPDATE_NEWS: (id) => `${API_REPORTER_BASE_URL}/getNewsByReporter/${id}`, 
     UPDATE_NEWS: (newsId) => `${API_REPORTER_BASE_URL}/getNewsByReporter/${newsId}`,
        
        DELETE_NEWS :`${API_REPORTER_BASE_URL}/getNewsByReporter`,

        CREATE_SHORT:`${API_REPORTER_BASE_URL}/shorts`,
        GET_MY_SHORTS:`${API_REPORTER_BASE_URL}/getMyShorts`,
     DELETE_SHORT: (shortId) => `${API_REPORTER_BASE_URL}/shorts/${shortId}`,
UPDATE_SHORT: `${API_REPORTER_BASE_URL}/shorts`,
          CREATE_VIDEO: `${API_REPORTER_BASE_URL}/video`,
          GET_ALL_VIDEOS: `${API_REPORTER_BASE_URL}/video`,
          UPDATE_VIDEO: `${API_REPORTER_BASE_URL}/video`,
          DELETE_VIDEO: `${API_REPORTER_BASE_URL}/video`,
        


          CREATE_STORY: `${API_REPORTER_BASE_URL}/createStory`,        // reporter khud story banaye (direct post nahi, approval jayegi)
  MY_STORIES: `${API_REPORTER_BASE_URL}/my-stories`,            // reporter ki apni saari stories (pending/posted/rejected)
  GET_STORY_BY_ID: `${API_REPORTER_BASE_URL}/stories`,                           // + /:storyId
  ADD_SLIDES: `${API_REPORTER_BASE_URL}/slides`,             // + /:storyId
  UPDATE_STORY: `${API_REPORTER_BASE_URL}`,                              // + /:storyId  (PUT)
  DELETE_STORY: `${API_REPORTER_BASE_URL}`, 

};